// extracted by mini-css-extract-plugin
module.exports = {"Section6":"Section6_Section6__Oa2_Z","Layout1":"Section6_Layout1__9P__F"};